import React, { useEffect, useState } from "react";
import { Page, Image, Text, Document, View, } from "@react-pdf/renderer";
import { styles } from "./StylosFacturacionMunicipios";
import escudoColombia from "../../images/Images/Magangue/Escudo Colombia.png";
import escudoColombiaSantaRosa from "../../images/Images/Santa Rosa/escudoColombiaSantaRosa.jpg";
import escudoSantaRosa from "../../images/Images/Santa Rosa/membreteSantaRosa.png";
import footerSantaRosa from "../../images/Images/Santa Rosa/footerSantaRosa.png";
import escudoMagangue from "../../images/Images/Magangue/Escudo Magangue.png";
import escudoSanJuanCesar from "../../images/Images/San Juan del Cesar/Escudo San Juan del Cesar.png";
import escudo1AlcaldiaSanJuanC from "../../images/Images/San Juan del Cesar/Escudo 1.png";
import membreteArjona from "../../images/Images/Arjona/membreteArjona.png";
import footerArjona from "../../images/Images/Arjona/footerArjona.png";
import membreteSanJacinto from "../../images/Images/San Jacinto/Membrete San Jacinto 1.png";
import membreteSanJacinto2 from "../../images/Images/San Jacinto/Membrete San Jacinto 2.png";
import membreteElPaso from "../../images/Images/El Paso/Membrete El Paso 1.png";
import membreteElPaso2 from "../../images/Images/El Paso/Membrete El Paso 2.png";
import escudosVillaNueva from "../../images/Images/Villanueva-Bolivar/Escudos Villanueva - Colombia.png";
import escudoVillaNueva2 from "../../images/Images/Villanueva-Bolivar/Escudo Villanueva-Bolivar.png";
import escudoAgustinCodazzi from "../../images/Images/Agustin Codazzi/Escudo Agustin Codazzi 2.png";
import membreteElCopey from "../../images/Images/El Copey/membreteElCopey.png";
import footerElCopey from "../../images/Images/El Copey/footerElCopey.png";
import escudoLaPaz from "../../images/Images/La Paz/Escudo La Paz.png";
import escudoRiohacha from "../../images/Images/Riohacha/Escudo Solo Riohacha.png";
import membreteRiohacha from "../../images/Images/Riohacha/Membrete Solo Riohacha.png";
import membreteTurbaco from "../../images/Images/Turbaco/membreteTurbaco.png";
import footerTurbaco from "../../images/Images/Turbaco/footerTurbaco.png";
import escudoFacatativa from "../../images/Images/Facatativa/Escudo Facatativa.png";
import membreteFacatativa from "../../images/Images/Facatativa/Membrete Facatativa.png";
import escudoCundinamarca from "../../images/Images/Facatativa/Escudo Cundinamarca.png";
import membreteAguachica1 from "../../images/Images/Aguachica/Membrete 1 - Aguachica.png";
import membreteAguachica2 from "../../images/Images/Aguachica/Membrete 2 - Aguachica.png";
import encabezado_neiva1 from '../../images/Neiva/encabezado_neiva1.png'
import encabezado_neiva2 from '../../images/Neiva/encabezado_neiva2.png'
import { currencyFormat } from "../../js/Functions";

const headerPDF = (alcaldia, data) => {
  switch (alcaldia) {
    case "NEIVA":
      return (
        <View style={styles.row}>
          <View style={[styles.col_img_header_neiva, {}]}>
            <Image style={styles.img} src={encabezado_neiva1} />
          </View>
          <View style={[styles.col_img_header_neiva, { width: "185px", borderLeft: 0 }]}>
            <View style={{ width: "185px" }}>
              <Text>OFICIO</Text>
            </View>
          </View>


          <View style={[styles.col_header_neiva_small, { borderTop: "1px solid black", borderBottom: "1px solid black" }]}>
            <View
              style={[styles.col_row_3_neiva_small, {}]}
            >
              <Text style={{ fontSize: "9px", marginTop: 4, padding: 3 }}>FOR-GDC-01</Text>

            </View>

            <View style={[styles.col_row_3_neiva_small, { borderTop: "1px solid black" }]}>
              <Text style={{ fontSize: "9px", padding: 3 }}>Versión: 01 </Text>
            </View>
            <View style={[styles.col_row_3_neiva_small, { borderTop: "1px solid black" }]}>
              <Text style={{ fontSize: "9px", padding: 3 }}>Vigente desde:</Text>
              <Text style={{ fontSize: "9px", padding: 3 }}>Marzo 19 del 2021</Text>
            </View>
          </View>

          <View style={[styles.col_img_header_neiva, {}]}>
            <Image style={styles.img} src={encabezado_neiva2} />
          </View>
        </View>
      )
    case "MAGANGUE":
      return (
        <View style={styles.row}>
         
          <View style={[styles.col_lg_3,]}>
            <Image style={styles.img} src={escudoMagangue} />
          </View>

          <View
            style={[
              styles.col_header_magangue,
              { marginRight: "1px", marginLeft: "1px" },
            ]}
          >
            <View style={[{ margin: "1px", width: "220px", }]}>
              <View style={[styles.col_row_3_magangue, { height: "27px", backgroundColor: '#a8d08d' }]}>
                <Text style={{ fontSize: "9px", marginTop: 4 }}>
                  ALCALDÍA MUNICIPAL DE {alcaldia}
                </Text>
                <Text style={{ fontSize: "9px" }}>NIT {data.NIT_ALCALDIA}</Text>
              </View>

              <View style={[styles.col_row_3_magangue, { backgroundColor: '#e2efd9' }]}>
                <Text style={{ fontSize: "9px", padding: 2 }}>
                  LIQUIDACIÓN IMPUESTO ALUMBRADO PÚBLICO
                </Text>
              </View>
              <View style={[styles.col_row_3_magangue,]}>
                <Text style={{ fontSize: "9px", padding: 2 }}>
                  SECRETARÍA DE HACIENDA MUNICIPAL
                </Text>
              </View>
            </View>

            {/* SEGUNDO */}

            <View style={[styles.col_header_magangue_small]}>
              <View
                style={[styles.col_row_3_magangue_small, { height: "26px",}]}
              >
                <Text style={{ fontSize: "7px", marginTop: 4 }}>Vigencia:</Text>
                <Text style={{ fontSize: "7px" }}>01/08/2018</Text>
              </View>

              <View style={[styles.col_row_3_magangue_small,]}>
                <Text style={{ fontSize: "7px", padding: 3 }}> </Text>
              </View>
              <View style={[styles.col_row_3_magangue_small, ]}>
                <Text style={{ fontSize: "7px", padding: 3 }}>Versión: 01</Text>
              </View>
            </View>
          </View>

          {/* <View style={[styles.col_header_magangue]}>
            <View style={[styles.col_row_3_magangue]}>
              <Text style={{ fontSize: "9px" }}>
                ALCALDIA MUNICIPAL DE MAGANGUE
              </Text>
              <Text style={{ fontSize: "9px" }}>NIT 8000284322</Text>
            </View>

            <View style={[styles.col_row_3_magangue]}>
              <Text style={{ fontSize: "8px" }}>
                LIQUIDACIÓN IMPUESTO ALUMBRADO PÚBLICO
              </Text>
            </View>
            <View style={[styles.col_row_3_2_magangue]}>
              <Text style={{ fontSize: "9px" }}>
                SECRETARÍA DE HACIENDA MUNICIPAL
              </Text>
            </View>
          </View> */}
          {/* <View style={[styles.col_header_magangue_small]}>
            <View style={[styles.col_row_3_magangue_small]}>
              <Text style={{ fontSize: "9px" }}>Vigencia:</Text>
              <Text style={{ fontSize: "9px" }}>01/08/2018</Text>
            </View>

            <View style={[styles.col_row_3_magangue_small]}>
              <Text style={{ fontSize: "9px" }}> </Text>
            </View>
            <View style={{ width: "59px" }}>
              <Text style={{ fontSize: "9px" }}>Versión: 01</Text>
            </View>
          </View> */}

          <View style={[styles.col_lg_3,]}>
            <Image style={{ height: 60 }} src={escudoColombia} />
          </View>
        </View>
      );
    case "SAN JUAN DEL CESAR":
      return (
        <View style={styles.row}>
          <View style={styles.col_img_header_sanJuanC}>
            <Image style={styles.img} src={escudoSanJuanCesar} />
          </View>
          <View style={[styles.col_img_header_sanJuanC, { width: "200px" }]}>
            <View style={{ width: "200px" }}>
              <Text style={{ fontSize: "9px" }}>REPUBLICA DE COLOMBIA</Text>
              <Text style={{ fontSize: "9px" }}>
                DEPARTAMENTO DE LA GUAJIRA
              </Text>
              <Text style={{ fontSize: "9px" }}>
                MUNICIPIO DE SAN JUAN DEL CESAR
              </Text>
              <Text style={{ fontSize: "9px" }}>NIT. {data.NIT_ALCALDIA}-0</Text>
              <Text style={{ fontSize: "9px" }}>
                DESPACHO DEL ALCALDE
              </Text>
            </View>
          </View>
          {/* <View style={[styles.col_img_header_sanJuanC]}>
            <Image style={styles.img} src={escudoAlcaldiaSanJuanCesar} />
          </View> */}

          <View style={styles.col_img_header_sanJuanC}>
            <Image style={styles.img} src={escudo1AlcaldiaSanJuanC} />
          </View>
        </View>
      );
    case "ARJONA":
      return (
        <View style={styles.row}>
          <View style={styles.col_img_header}>
            <Image style={[{  }]} src={membreteArjona} />
          </View>
        </View>
      );
    case "SAN JACINTO":
      return (
        <View style={styles.row}>
          <View style={styles.col_img_header}>
            <Image style={[{ maxWidth: "60%" }]} src={membreteSanJacinto} />
          </View>
        </View>
      );
    case "EL PASO":
      return (
        <View style={styles.row}>
          <View style={styles.col_img_header}>
            <Image style={[{ maxWidth: "60%" }]} src={membreteElPaso} />
          </View>
        </View>
      );
    case "SANTA ROSA":
      return (
        <View style={styles.row}>
          <View style={[styles.col_lg_3_r, { marginRight: 1 }]}>
            <Image style={styles.img} src={escudoColombiaSantaRosa} />
          </View>
          <View style={[styles.col_header_santaR, { marginRight: 1 }]}>
            <View style={[styles.col_row_3_2]}>
              <Text style={[styles.color_text_row]}>REPÚBLICA DE COLOMBIA</Text>
              <Text style={[styles.color_text_row]}>DEPARTAMENTO DE BOLÍVAR</Text>
              <Text style={[styles.color_text_row,]}>MUNICIPIO DE SANTA ROSA</Text>
              <Text style={[styles.color_text_row,]}>ALCALDÍA MUNICIPAL</Text>
              <Text style={[styles.color_text_row]}>NIT: 890.481.343-3</Text>
            </View>
          </View>
          <View style={styles.col_lg_3_r}>
            <Image style={styles.img} src={escudoSantaRosa} />
          </View>
          <View
              style={[
                styles.view,
                { borderTop: "6px solid #EA0000", marginTop: "5px" },
              ]}
            ></View>
          <View
              style={[
                styles.view,
                { borderTop: "3px solid #00B050", marginTop: "2px" },
              ]}
            ></View>
            
        </View>
      );
    case "VILLANUEVA-BOLIVAR":
      return (
        <View style={styles.row}>
          <View style={styles.col_img_header}>
            <Image style={[{ maxWidth: "60%" }]} src={escudosVillaNueva} />
          </View>
        </View>
      );
    case "AGUSTIN CODAZZI":
      return (
        <View>
          <View style={styles.row}>
            <View style={styles.col_lg_3_agustin}>
              <Image style={styles.img} src={escudoAgustinCodazzi} />
            </View>
            <View style={[styles.col_header_agustinC]}>
              <Text style={{ fontSize: "10px" }}>REPUBLICA DE COLOMBIA</Text>
              <Text style={{ fontSize: "10px" }}>DEPARTAMENTO DEL CESAR</Text>
              <Text style={{ fontSize: "10px" }}>
                ALCALDÍA MUNICIPAL DE {alcaldia} CESAR
              </Text>
              <Text style={{ fontSize: "10px" }}>NIT. No. 800. 096.558-1</Text>
            </View>
          </View>
        </View>
      );
    case "EL COPEY":
      return (
        <View style={styles.row}>
          <Image style={{}} src={membreteElCopey} />
        </View>
      );
    case "LA PAZ":
      return (
        <View style={styles.row}>
          <View style={[styles.col_lg_3, { marginRight: 1 }]}>
            <Image style={styles.img} src={escudoLaPaz} />
          </View>
          <View style={[styles.col_header_laPaz, { marginRight: 1 }]}>
            <View style={[styles.col_header_laPaz_small2]}>
              <Text style={{ fontSize: "12px" }}>
                ALCALDÍA MUNICIPAL DE {alcaldia}
              </Text>
              <Text style={{ fontSize: "12px" }}>NIT {data.NIT_ALCALDIA}</Text>
            </View>
            <View style={[{ display: "flex", flexDirection: "row" }]}>
              <View style={[styles.col_header_laPaz_small, { width: "78px" }]}>
                <Text>Codigo: 110</Text>
              </View>
              <View style={[styles.col_header_laPaz_small, { width: "118px" }]}>
                <Text>Versión: 1 Fecha 01-2013</Text>
              </View>
              <View style={[styles.col_header_laPaz_small, { width: "78px" }]}>
                <Text>Pág: 1 de 1</Text>
              </View>
            </View>
          </View>

          <View style={styles.col_lg_3}>
            <Image style={styles.img} src={escudoLaPaz} />
          </View>
        </View>
      );
    case "RIOHACHA":
      return (
        <View style={styles.row}>
          <View style={[styles.col_img_header, { border: 0 }]}>
            <Image style={[{ maxWidth: "30%" }]} src={escudoRiohacha} />
          </View>
        </View>
      );
    case "TURBACO":
      return (
        <View style={styles.row}>
          <Image style={[{ }]} src={membreteTurbaco} />
        </View>
      );
    case "FACATATIVA":
      return (
        <View style={styles.row}>
          <View style={styles.col_lg_3}>
            <Image style={styles.img} src={escudoFacatativa} />
          </View>
          <View style={[styles.col_header_facatativa]}>
            <View style={[]}>
              <Text style={[styles.text_facatativa]}>
                LIQUIDACIÓN OFICIAL DE IMPUESTO DE ALUMBRADO PÚBLICO
              </Text>
              <Text style={[styles.text_facatativa]}>
                REPÚBLICA DE COLOMBIA
              </Text>
              <Text style={[styles.text_facatativa]}>
                DEPARTAMENTO DE CUNDINAMARCA
              </Text>
              <Text style={[styles.text_facatativa]}>
                MUNICIPIO DE FACATATIVA
              </Text>
            </View>
          </View>

          <View style={styles.col_lg_3}>
            <Image
              style={[styles.img, { width: "100%" }]}
              src={escudoCundinamarca}
            />
          </View>
        </View>
      );
    case "AGUACHICA":
      return (
        <View style={styles.row}>
          <View style={[styles.col_img_header, { border: "0px" }]}>
            <Image style={[{ maxWidth: "100%" }]} src={membreteAguachica1} />
          </View>
        </View>
      );
    default:
      return (
        <View style={styles.row}>
          <Text style={{ color: "red" }}>
            NOTA: NO EXISTE CABEZERA PARA ESTÁ ALCALDÍA. POR FAVOR VERIFICAR CON
            LOS INGENIEROS DE SISTEMAS
          </Text>
        </View>
      );
  }
};

const fechasPDF = (alcaldia, data) => {
  switch (alcaldia) {
    case "FACATATIVA":
      break;
    default:
      return (
        <View style={[styles.row, styles.row_align]}>
          <View style={[]}>
            <Text style={[]}>Fecha Emisión: {formatDateString(data.FECHA_CREACION.slice(0, 10))}</Text>
          </View>
          <View style={[styles.p_end]}>
            <Text style={[]}>Fecha Impresión: {formatDate(new Date())}</Text>
          </View>
        </View>
      );
  }
};

const mainText = (alcaldia, data) => {
  switch (alcaldia) {
    case "FACATATIVA":
      return (
        <View style={{ border: "1px solid black", marginBottom: "2px" }}>
          <Text
            style={{
              paddingBottom: "0px",
              margin: "5px",
              textAlign: "center",
              fontSize: "10.5px",
            }}
          >
            La Secretaría de Hacienda del Municipio de Facatativá Cundinamarca,
            en uso de las atribuciones conferidas por los artículos 684, 686,
            688 del Estatuto Tributario Nacional y El Acuerdo Municipal 007 de
            2018 por medio del cual se actualiza el Estatuto Tributario
            Municipal, Expide la presente Liquidación Oficial del impuesto de
            Alumbrado Público:
          </Text>
        </View>
      );
    default:
      return (
        <View>
          <View style={[styles.row, styles.p_center, { marginTop: "10px" }]}>
            <Text style={[]}>LIQUIDACIÓN OFICIAL NO. {data.CONSECUTIVO_FACT}</Text>
          </View>
          <View style={[styles.row, styles.p_center, { marginBottom: "10px" }]}>
            <Text style={[]}>IMPUESTO ALUMBRADO PÚBLICO</Text>
          </View>
          <View
            style={[
              styles.view,
              { borderTop: "3px solid #C4C4C4", margin: "0px" },
            ]}
          ></View>
          <Text style={{ paddingBottom: "15px", marginTop: "5px" }}>
            La Secretaría de Hacienda del Municipio de {data.MUNICIPIO}, en uso de las
            atribuciones conferidas por los artículos 684, 686, 688 del Estatuto
            Tributario Nacional y El {data.ACUERDO_MCPAL.toUpperCase()} por medio del
            cual se actualiza el Estatuto Tributario Municipal, expide la
            presente Liquidación Oficial del impuesto de Alumbrado Público:
          </Text>
        </View>
      );
  }
};

const bodyPDF = (alcaldia, data) => {
  switch (alcaldia) {
    // case "NEIVA":
    //   return (
    //     <View>
    //       <Text style={[{ marginBottom: 25 }]}>Oficio No.xxxxxxxx</Text>
    //       <Text>Señores:</Text>
    //       <Text>NOMBRE CONTRIBUYENTE</Text>
    //       <Text>NIT</Text>
    //       <Text>Att. XXXXXXXXXXXXXXXX</Text>
    //       <Text>DIRECCION CONTRIBUYENTE</Text>
    //       <Text>CORREO </Text>
    //       <Text>TELEFONO/CELULAR</Text>
    //       <Text >Neiva, Huila  </Text>
    //       <View style={[{ marginTop: 30, height: 15, border: '1px solid black', justifyContent: "center", textAlign: "center", }]}>
    //         <Text>Asunto: Notificación cuenta cuenta de Fideicomiso recaudo Impuesto de Alumbrado Público - Solicitud consignación.  </Text>
    //       </View>
    //       <Text style={[{ marginTop: 15, marginBottom: 15 }]}>Cordial saludo:</Text>
    //       <Text>La Secretaría de Hacienda del Municipio de Neiva, en uso de sus atribuciones legales, conferidas por el Acuerdo Municipal 
    //       028 de 2018 y el Decreto 0474 del 15 de julio de 2021, en especial las que corresponden a las facultades de fiscalización 
    //       y control de los tributos del orden municipal, formalmente se le requiere para que proceda a consignar o trasladar, 
    //       según el caso de actuar como contribuyente o agente recaudador, los valores correspondientes al impuesto de alumbrado 
    //       público o recaudados por este concepto, en la siguiente cuenta: </Text>
    //       <Text style={[{ marginTop: 10, marginBottom: 10}]}>
    //       Cuenta de Ahorros 800-037673 del Banco de Occidente - Patrimonios autónomos Acción FIDUC - FA 5618 Fideicomiso Alumbrado Público de Neiva.
    //       </Text>
    //       <Text>
    //       Lo anterior, considerando que mediante Acuerdo 026 de diciembre de 2020, el Concejo Municipal de Neiva, concedió 
    //       autorización para crear una Empresa de Servicios Públicos Mixta EMPRESA DE SERVICIOS DE ILUMINACIÓN PÚBLICA Y
    //       DESARROLLOS TECNOLÓGICOS DE NEIVA S.A.S. E.S.P.- ESIP S.A.S E.S.P encargada de prestar el servicio de Alumbrado 
    //       Público, así como desarrollos tecnológicos asociados, e iluminación ornamental y navideña, en el Municipio de Neiva.
    //       </Text>
    //       <Text style={[{ marginTop: 10, marginBottom: 10}]}>El citado acuerdo municipal autorizó al Alcalde Municipal de Neiva para transferir a favor de la empresa 
    //       ESIP S.A.S. E.S.P, los recursos del recaudo del impuesto de alumbrado público, los cuales serán administrados 
    //       por un encargo fiduciario que contratará la sociedad para tal fin, el cual tendrá las prioridades y distribución 
    //       referidas en las líneas anteriores. (...), según lo dispuesto en los términos de referencia de la Convocatoria Pública 
    //       descripción del modelo de negocio propuesto en la selección del accionista privado para la constitución de la empresa 
    //       ESIP S.A.S. E.S.P.</Text>
    //       <Text>
    //       La administración municipal dentro del proceso de gestión de control a la renta de alumbrado público, 
    //       verifica que la empresa objeto del presente oficio tenía como como agente de recaudo del impuesto 
    //       de alumbrado público a la empresa comercializadora de energía eléctrica DICEL S.A. E.S.P., 
    //       la cual mediante notificación por correo electrónico del día 17 de mayo de 2023 indicó que 
    //       facturó y recaudo el impuesto de alumbrado público hasta el periodo 202302; que el contribuyente 
    //       pasaría al comercializador XXXXX a partir de XXXXXX, dejando así pendiente por pagar los periodos de 
    //       202303, 202304, 202305, motivo por el cual se solicita atender el presente requerimiento, de manera 
    //       que administración y administrados procedan a dar cumplimiento a las disposiciones normativas aprobadas 
    //       mediante Decreto 0474 de 2021, así como las demás regulaciones previstas en el nuevo modelo de negocio 
    //       para atender eficiente y eficazmente el sistema de alumbrado público del Municipio de Neiva.
    //       </Text>
    //       <Text style={[{ marginTop: 20, marginBottom: 10}]}>
    //       La tarifa a cancelar por concepto del impuesto de alumbrado público para cada periodo es:
    //       </Text>
    //     </View>
    //   )
    case "FACATATIVA":
      return (
        <View
          style={[styles.row, { border: "1px solid black", fontSize: "7.5px" }]}
        >
          <Text style={[{ padding: "2px" }]}>1. AÑO GRABABLE:</Text>
          {[...data.PERIODO_FACTURA.slice(0, 4)].map((letter, index) => {
            return (
              <Text key={index} style={[styles.text_border]}>{letter}</Text>
            )
          })}

          <Text style={[{ marginLeft: 20, padding: "2px" }]}>2. PERIODO:</Text>
          {/* PERIODO */}
          {/* Copy of the month returned */}
          {[...getMonth(data.PERIODO_FACTURA).toUpperCase()].map((letter, index) => {
            return (
              <Text key={index} style={[styles.text_border,]}>
                {letter}
              </Text>
            );
          })}
          {/* A. INFORMACIÓN DEL CONTRIBUYENTE */}

          <View
            style={[
              styles.row,
              {
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                marginTop: "5px",
                backgroundColor: "#8497B0",
              },
            ]}
          >
            <Text>A. INFORMACIÓN DEL CONTRIBUYENTE</Text>
          </View>
          <View style={[styles.row, { marginTop: "0px" }]}>
            <Text>3. APELLIDOS Y NOMBRES O RAZÓN SOCIAL</Text>
          </View>
          <View style={[styles.row]}>
            {[...data.NOMBRE].map((letter, index) => {
              return (
                <Text
                  style={[styles.text_border, { marginBottom: "2px" }]}
                  key={index}
                >
                  {letter}
                </Text>
              );
            })}
          </View>
          <View style={[styles.row, { marginTop: "0px" }]}>
            <Text>4. IDENTIFICACIÓN DEL RESPONSABLE</Text>
          </View>
          {/* TABLE */}
          <View style={[]}>
            <View style={[styles.row]}>
              <Text style={[styles.table_row1, { border: "0" }]}>CC</Text>
              <Text style={[styles.table_row1, { border: "0" }]}>NIT</Text>
              <Text style={[styles.table_row1, { border: "0" }]}>TI</Text>
              <Text
                style={[
                  styles.table_row1,
                  { border: "0", marginRight: "20px" },
                ]}
              >
                CE
              </Text>

              <Text style={[styles.table_row2, {}]}>NÚMERO</Text>
              <Text
                style={[
                  styles.table_row1,
                  { border: "1px solid black", marginRight: "25px" },
                ]}
              >
                DV
              </Text>
              <Text style={[{}]}>5. TELÉFONO FIJO O MÓVIL</Text>
            </View>

            <View style={[styles.row]}>
              <Text style={[styles.table_row1, {}]}></Text>
              <Text style={[styles.table_row1, {}]}>X</Text>
              <Text style={[styles.table_row1, {}]}></Text>
              <Text style={[styles.table_row1, { marginRight: "20px" }]}></Text>

              {/* NÚMERO */}
              {[...data.NIT_CONTRIBUYENTE.slice(0, 9)].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
              {/* NÚMERO */}
              <Text style={[]}>-</Text>
              <Text style={[styles.table_row1, { marginRight: "25px" }]}>
                {data.NIT_CONTRIBUYENTE.slice(-1)}
              </Text>

              {/* 5. TELÉFONO FIJO O MÓVIL */}

              {[...data.NIT_CONTRIBUYENTE].map((number, index) => (
                number <= 14 ?
                  (

                    <Text key={index} style={[styles.text_border, {}]}>
                      {number}
                    </Text>
                  )
                  :
                  ""
              ))}
              {/* 5. TELÉFONO FIJO O MÓVIL */}
            </View>

            <View style={[styles.row, { marginTop: "5px" }]}>
              <Text style={[{ fontSize: "6px" }]}>
                6. DIRECCIÓN DE NOTIFICACIÓN. Escriba la dirección donde la
                Secretaria de Hacienda puede comunicarse con usted. Recuerde el
                apartado aéreo no sirve como dirección de notificación
              </Text>
            </View>
            <View style={[styles.row, { paddingTop: "0" }]}>
              {/* DIRECCION CONTRIBUYENTE */}
              {[...data.DIRECCION_CONTRIBUYENTE].map((letter, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {letter}
                  </Text>
                );
              })}
            </View>
            <View style={[styles.row]}>
              <View style={[styles.row]}>
                <Text>6.1 CIUDAD</Text>
              </View>

              {/* CIUDAD O NOMBRE DE MUNICIPIO */}
              {[...data.MUNICIPIO].map((letter, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {letter}
                  </Text>
                );
              })}
            </View>

            <View
              style={[
                styles.row,
                {
                  marginTop: "5px",
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                  width: "503",
                  backgroundColor: "#8497B0",
                },
              ]}
            >
              <Text>B. PAGO</Text>
            </View>
            <View style={[styles.row, { marginTop: "5px" }]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                7. PERIODO CORRIENTE
              </Text>
              {[...getMonth(data.PERIODO_FACTURA).toUpperCase()].map((letter, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {letter}
                  </Text>
                );
              })}

              <Text
                style={[
                  { marginLeft: "15px", marginRight: "1px", padding: "2px" },
                ]}
              >
                8. NO. LIQUIDACIONES VENCIDAS
              </Text>
              {[...data.NO_LIQ_VENCIDAS.toString()].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
            </View>

            <View style={[styles.row, { marginTop: "5px" }]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                9. SECTOR Y/O ACTIVIDAD
              </Text>

              {[...data.SECTOR_CONTRIBUYENTE].map((letter, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {letter}
                  </Text>
                );
              })}
            </View>

            <View style={[styles.row, {}]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                10. TIPO DE BASE GRAVABLE
              </Text>
              {/* {getBaseGravable(data.ID_TIPO_FACTURACION)} */}
              {
                data.ID_TIPO_FACTURACION === 1 ?
                  (
                    [...'VALOR CONSUMO DE ENERGIA'].map((letter, index) => {
                      return (
                        <Text key={index} style={[styles.text_border, {}]}>
                          {letter}
                        </Text>
                      )
                    })

                  )
                  :
                  data.ID_TIPO_FACTURACION === 2 ?
                    (
                      [...'VALOR SMMLV'].map((letter, index) => {
                        return (
                          <Text key={index} style={[styles.text_border, {}]}>
                            {letter}
                          </Text>
                        )
                      })
                    )
                    :
                    ""
              }

            </View>

            <View style={[styles.row, {}]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                11. VALOR BASE GRAVABLE
              </Text>
              {[...data.VALOR_TARIFA.toString()].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "10px" },
                ]}
              >
                12. TARIFA
              </Text>
              {
                data.ID_TIPO_FACTURACION === 1 ?
                  (
                    [...data.TARIFA.toString() + '%'].map((number, index) => {
                      return (
                        <Text key={index} style={[styles.text_border, {}]}>
                          {number}
                        </Text>
                      )
                    })
                  )
                  :
                  data.ID_TIPO_FACTURACION === 2 ?
                    (
                      [...data.TARIFA.toString()].map((number, index) => {
                        return (
                          <Text key={index} style={[styles.text_border, {}]}>
                            {number}
                          </Text>
                        )
                      })
                    )
                    :
                    ""
              }

            </View>

            <View style={[styles.row, {}]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                13. VALOR IMPUESTO MENSUAL
              </Text>
              {[...data.VALOR_FACTURA.toString()].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "10px" },
                ]}
              >
                14. VALOR SANCIÓN
              </Text>
              {[...'0'].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}

              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "10px" },
                ]}
              >
                15. INTERESES POR MORA
              </Text>
              {[...'0'].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
            </View>

            <View style={[styles.row, {}]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0px" },
                ]}
              >
                16. PAGO TOTAL
              </Text>
              {[...`${data.VALOR_FACTURA + data.VALOR_LIQ_VENCIDAS}`].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "10px" },
                ]}
              >
                17. FECHA
              </Text>
              {[...formatDateString(data.FECHA_FACTURA).replaceAll('/', '')].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
            </View>

            <View style={[styles.row, {}]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0px" },
                ]}
              >
                18. CUENTA DE AHORROS DEL {data.BANCO_FIDUCIA}
              </Text>
              {[...data.CUENTA_FIDUCIA.toString()].map((number, index) => {
                return (
                  <Text key={index} style={[styles.text_border, {}]}>
                    {number}
                  </Text>
                );
              })}
            </View>

            <View style={[styles.row, { marginBottom: "5px" }]}>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                19. A NOMBRE DE:
              </Text>
              <Text style={[styles.text_border, { marginRight: "10px" }]}>
                {data.NOMBRE_FIDUCIA}
              </Text>
              <Text
                style={[
                  { marginRight: "1px", padding: "2px", paddingLeft: "0" },
                ]}
              >
                20. NIT:
              </Text>
              <Text style={[styles.text_border, {}]}>{data.NIT_FIDUCIA}</Text>
            </View>

            {/* PARRAFO LARGO */}

            <View
              style={[
                styles.row,
                { borderTop: "1px solid black", width: "503px" },
              ]}
            >
              <Text style={[{ marginRight: "4px", marginLeft: "2px" }]}>
                El Contribuyente es sujeto pasivo del impuesto de Alumbrado
                Público por cuanto: i) Se analizó y determinó que es usuario
                potencial del servicio ii) Está clasificado de acuerdo a los
                principios de progresividad y equidad en materia tributaria iii)
                Opera o posee cualquier tipo de infraestructura en el Municipio
                y/o tiene establecimiento físico en la jurisdicción del
                Municipio y iv) en virtud de lo anterior, cumple el hecho
                generador del impuesto de alumbrado público que es el beneficio
                por la prestación del mismo.
              </Text>
              <Text style={[{ marginRight: "4px", marginLeft: "2px" }]}>
                Los artículos 12 y 13 del Acuerdo No. 007 de 2018 fijaron la
                base gravable y la tarifa del impuesto de alumbrado público de
                acuerdo al tipo de usuario y actividad que desarrolla
              </Text>

              <Text style={[{ marginRight: "4px", marginLeft: "2px" }]}>
                Contra la presente Liquidación Oficial del Impuesto de Alumbrado
                Público, procede el recurso de reconsideración de que trata el
                artículo 720 del Estatuto Tributario Nacional, el cual deberá
                interponerse dentro de los dos (2) meses siguientes a su
                notificación, cumpliendo los requisitos señalados en el artículo
                722 del mismo ordenamiento jurídico, y presentarla en la oficina
                de la Secretaria de Hacienda del Municipio de Facatativá
                Cundinamarca.
              </Text>
            </View>
            <View
              style={[
                styles.row,
                { width: "503px", borderTop: "1px solid black" },
              ]}
            >
              <Text>
                Nota esta LIQUIDACIÓN OFICIAL DE IMPUESTO DE ALUMBRADO PÚBLICO
                deberá pagarse a más tardar el último día hábil de mes siguiente
                a su liquidación periodo gravable.
              </Text>
            </View>
          </View>
        </View>
      );
    default:
      return (
        <View style={[styles.row]}>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197, backgroundColor: "#003153" }}>
              <Text style={[{ color: "#FFFFFF" }]}>CONTRIBUYENTE:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305, backgroundColor: "#003153" }}>
              <Text style={[{ color: "#FFFFFF" }]}>
                {data.NOMBRE}
              </Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>NIT:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>{data.NIT_CONTRIBUYENTE}</Text>
            </View>
          </View>
          <View
            style={[styles.table_row_left,]}
          >
            <View style={{ width: 197 }}>
              <Text>DIRECCIÓN:</Text>
            </View>
          </View>
          <View
            style={[styles.table_row_right,]}
          >
            <View style={{ width: 305 }}>
              <Text>{data.DIRECCION_CONTRIBUYENTE}</Text>
            </View>
          </View>
          {/* Brake */}
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>PERIODO CORRIENTE:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>{`${getMonth(data.PERIODO_FACTURA).toUpperCase()} DE ${data.PERIODO_FACTURA.slice(0, 4)}`}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>NO. LIQUIDACIONES VENCIDAS:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>{data.NO_LIQ_VENCIDAS}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>VALOR TOTAL LIQUIDACIONES VENCIDAS: </Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>$ {currencyFormat(data.VALOR_LIQ_VENCIDAS)}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>SECTOR:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>{data.SECTOR_CONTRIBUYENTE}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>TARIFA:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              {getTarifa(data.ID_TIPO_FACTURACION, data.TARIFA)}
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>BASE GRAVABLE / UVT / S.M.L.V.: </Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>$ {currencyFormat(data.VALOR_TARIFA)}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197 }}>
              <Text>VALOR IMPUESTO</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 305 }}>
              <Text>$ {currencyFormat(data.VALOR_FACTURA)}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 197, backgroundColor: "#003153" }}>
              <Text style={[{ color: "#FFFFFF" }]}>VALOR TOTAL PERIODO:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: "305px", backgroundColor: "#003153" }}>
              <Text style={[{ color: "#FFFFFF" }]}>$ {currencyFormat(data.VALOR_FACTURA + data.VALOR_LIQ_VENCIDAS)}</Text>
            </View>
          </View>
          <View
            style={[styles.table_row_left, { borderBottom: "1px solid black" }]}
          >
            <View style={{ width: "197px", backgroundColor: "#003153" }}>
              <Text style={[{ color: "#FFFFFF" }]}>FECHA VENCIMIENTO:</Text>
            </View>
          </View>
          <View
            style={[
              styles.table_row_right,
              { borderBottom: "1px solid black" },
            ]}
          >
            <View style={{ width: 305, backgroundColor: "#003153" }}>
              <Text style={[{ color: "#FFFFFF" }]}>{formatDateString(data.FECHA_VENCIMIENTO)}</Text>
            </View>
          </View>
          <Text style={{ marginTop: "5px" }}>
            Adjunto relación de valores liquidados.
          </Text>
          <Text style={{ marginTop: "15px", }}>
            El Contribuyente es sujeto pasivo del impuesto de Alumbrado Público
            por cuanto: i) Se analizó y determinó que es usuario potencial del
            servicio ii) Está clasificado de acuerdo a los principios de
            progresividad y equidad en materia tributaria. iii) Opera o posee
            cualquier tipo de infraestructura en el Municipio y/o tiene
            establecimiento físico en la jurisdicción del Municipio y iv) en
            virtud de lo anterior, cumple el hecho generador del impuesto de
            alumbrado público que es el beneficio por la prestación del mismo.
            Los contribuyentes del Impuesto de Alumbrado Público están en la
            obligación de aplicar las tarifas correspondientes a cada sector y
            de realizar el pago mensual, según lo establecido en el {data.ACUERDO_MCPAL.toUpperCase()}.
          </Text>
          <Text style={[{ marginBottom: "15px" }]}>
            Las facturas vencidas generan intereses
            moratorios por cada día de retraso.
          </Text>
          <View
            style={[
              styles.row,
              styles.p_center,
              { backgroundColor: "#003153" },
            ]}
          >
            <View style={{ marginBottom: 5 }}>
              <Text style={[{ color: "#FFFFFF" }]}>
                CONSIGNAR EN LA SIGUIENTE CUENTA
              </Text>
            </View>
          </View>
          {/* Last table */}
          <View style={[styles.table_row_left]}>
            <View style={{ width: 240 }}>
              <Text>CUENTA DE AHORROS DEL {data.BANCO_FIDUCIA}: </Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 262 }}>
              <Text>{data.CUENTA_FIDUCIA}</Text>
            </View>
          </View>
          <View style={[styles.table_row_left]}>
            <View style={{ width: 240 }}>
              <Text>A NOMBRE DE:</Text>
            </View>
          </View>
          <View style={[styles.table_row_right]}>
            <View style={{ width: 262 }}>
              <Text>
                {data.NOMBRE_FIDUCIA}
              </Text>
            </View>
          </View>
          <View
            style={[styles.table_row_left, { borderBottom: "1px solid black" }]}
          >
            <View style={{ width: 240 }}>
              <Text>NIT:</Text>
            </View>
          </View>
          <View
            style={[
              styles.table_row_right,
              { borderBottom: "1px solid black" },
            ]}
          >
            <View style={{ width: 262 }}>
              <Text>{data.NIT_FIDUCIA}</Text>
            </View>
          </View>
          <Text style={{ marginTop: "5px" }}>
            Enviar soporte de pago al correo electrónico: <Text style={{ textDecoration: "underline" }}>{data.CORREO_ELECTRONICO_ALCALDIA}</Text>
          </Text>
          <Text style={{ marginTop: "10px" }}>
            Contra la presente Liquidación Oficial del Impuesto de Alumbrado
            Público, procede el recurso de reconsideración de que trata el
            artículo 720 del Estatuto Tributario Nacional, el cual deberá
            interponerse dentro de los dos (2) meses siguientes a su
            notificación, cumpliendo los requisitos señalados en el artículo 722
            del mismo ordenamiento jurídico, y presentarla en la oficina de la
            Secretaria de Hacienda del Municipio.
          </Text>
        </View>
      );
  }
};

const footerPDF = (alcaldia, data) => {
  switch (alcaldia) {
    case "NEIVA":
      return(
        <View style={styles.row}>
        <View
          style={{
            marginTop: "80px",
            marginBottom: "10px",
          }}
        >
          <View style={[styles.row, styles.p_center]}>
            <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
          </View>
          <View style={[styles.row, styles.p_center]}>
            <Text>Director de Rentas</Text>
          </View>
        </View>
      </View>
      )
    case "MAGANGUE":
      return (
        <View>
          <View style={{ marginTop: "50px", marginBottom: "10px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>SECRETARIO DE HACIENDA</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>Magangué (Bolivar)</Text>
            </View>
          </View>
          <View>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>"Magangué educada, comunal e incluyente"</Text>
            </View>
            <View style={[styles.p_center]}>
              <View style={[styles.line_footer_magangue]}></View>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>
                Alcadía Municipal de Magangué - Calle 16B No. 16a - 208 Barrio
                San Martín
              </Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>Teléfono: 6877720 - 6876020</Text>
            </View>
            <View style={[styles.p_center]}>
              <View style={[styles.line_footer_magangue]}></View>
            </View>
          </View>
        </View>
      );
    case "SAN JUAN DEL CESAR":
      return (
        <View>
          <View style={{ marginTop: "40px", marginBottom: "10px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View style={{ marginTop: "5px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>
                Dirección: Calle 7 # 9ª-36 Avenida Manuel Antonio Dávila –
                Teléfono: (095) 7740090
              </Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>
                – (095) 7740000 www.sanjuandelcesar-laguajira.gov.co - Email:
              </Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text style={[{}]}>
                alcaldia@sanjuandelcesar-laguajira.gov.co Código Postal: 444030
              </Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <View
                style={{ width: "350px", border: "1px solid #C4C4C4" }}
              ></View>
            </View>
          </View>
        </View>
      );
    case "ARJONA":
      return (
        <View>
          <View
            style={{
              marginTop: "40px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View style={[styles.row,]}>
            <Image style={[{}]} src={footerArjona} />
          </View>
        </View>
      );
    case "EL PASO":
      return (
        <View>
          <View
            style={{
              marginTop: "40px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View style={[styles.row, { justifyContent: "center" }]}>
            <Image style={[{ width: "320px" }]} src={membreteElPaso2} />
          </View>
        </View>
      );
    case "SAN JACINTO":
      return (
        <View>
          <View
            style={{
              marginTop: "40px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View style={[styles.row, { justifyContent: "center" }]}>
            <Image style={[{ width: "280px" }]} src={membreteSanJacinto2} />
          </View>
        </View>
      );
    case "SANTA ROSA":
      return (
        <View>
          <View style={{ marginTop: "50px", marginBottom: "10px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
        <Image style={{}} src={footerSantaRosa} />
      </View>
      );
    case "VILLANUEVA-BOLIVAR":
      return (
        <View>
          <View
            style={{
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View style={[styles.row, { justifyContent: "center" }]}>
            <Image style={[{ width: "280px" }]} src={escudoVillaNueva2} />
          </View>
        </View>
      );
    case "AGUSTIN CODAZZI":
      return (
        <View>
          <View style={{ marginTop: "100px", marginBottom: "10px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIA DE HACIENDA</Text>
            </View>
          </View>
          <View style={{ marginTop: "5px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{fontSize: 11}}>
                Carrera 16 No. 17 - 02. Agustín Codazzi, Cesar
              </Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{fontSize: 11}}>Teléfono: (57) 5 5765733 - Fax: (57) 5 5765733</Text>
            </View>
          </View>
        </View>
      );
    case "EL COPEY":
      return (
        <View>
          <View style={{ marginTop: "80px", marginBottom: "20px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View> <Image style={[{}]} src={footerElCopey} /></View>
        </View>
      );
    case "LA PAZ":
      return (
        <View>
          <View style={{ marginTop: "20px", marginBottom: "10px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
          <View style={{ marginTop: "5px" }}>
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>LA PAZ SOMOS TODOS</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>
                Palacio Municipal: Cra. 7 No. 8A -09 La Paz Cesar Colombia /
                Telefax: (095) 5771240
              </Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>
                <Text style={[{ textDecoration: "underline" }]}>
                  www.lapazrobles-cesar.gov.co
                </Text>{" "}
                / E:mail: alcaldia@lapazrobles-cesar.gov.co
              </Text>
            </View>
          </View>
        </View>
      );
    case "RIOHACHA":
      return (
        <View style={[styles.row, {}]}>
          <View
            style={{
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>DIRECTORA DE RENTAS</Text>
            </View>
          </View>
          <View style={[styles.col_footer_riohacha, { width: "505px" }]}>
            <Image
              style={[
                { width: "505px", height: "80px", },
              ]}
              src={membreteRiohacha}
            />
          </View>
        </View>
      );
    case "TURBACO":
      return (
        <View style={[styles.row, {}]}>
          <View
            style={{
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>

          <View
            style={[
              styles.row,
              { marginTop: "30px" },
            ]}
          >
            <Image style={[{}]} src={footerTurbaco} />
          </View>
        </View>
      );

    case "FACATATIVA":
      return (
        <View
          style={[styles.row, { border: "1px solid black", borderTop: "0" }]}
        >
          <View style={[styles.row]}></View>
          <View
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              borderTop: "1px solid black",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>SECRETARIO DE HACIENDA</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>MUNICIPIO DE FACATATIVA</Text>
            </View>
          </View>
          {/* SECOND PART */}

          <View style={[styles.row, { borderTop: "1px solid black" }]}>
            <View style={styles.col_footer_facatativa}>
              <Image style={[{}]} src={membreteFacatativa} />
            </View>
            <View style={[{ width: "100px" }]}></View>

            <View style={[styles.col_footer_facatativa2]}>
              <Text style={{ borderBottom: "1px solid black" }}>
                CÓDIGO: GF-FR-152
              </Text>
              <Text style={{ borderBottom: "1px solid black" }}>
                VERSIÓN: 01
              </Text>
              <Text style={{ borderBottom: "1px solid black" }}>
                FECHA: 21 AGO 2020
              </Text>
              <Text style={{}}>DOCUMENTO CONTROLADO</Text>
            </View>
          </View>
        </View>
      );
    case "AGUACHICA":
      return (
        <View style={[styles.row, {}]}>
          <View
            style={{
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>

          <View
            style={[
              styles.row,
              { justifyContent: "center", marginTop: "10px" },
            ]}
          >
            <Image style={[{ height: "42px" }]} src={membreteAguachica2} />
          </View>
        </View>
      );
    default:
      return (
        <View style={styles.row}>
          <View
            style={{
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            <View style={[styles.row, styles.p_center]}>
              <Text style={{}}>{data.NOMBRE_SEC_HACIENDA}</Text>
            </View>
            <View style={[styles.row, styles.p_center]}>
              <Text>SECRETARIO DE HACIENDA</Text>
            </View>
          </View>
        </View>
      );
  }
};


const getTarifa = (tipoTarifa, tarifa) => {
  switch (tipoTarifa) {
    case 1:
      return (<Text>{tarifa}% DEL CONSUMO DE ENERGÍA</Text>);
    case 2:
      return (<Text>{tarifa} SMMLV</Text>)
    case 3:
      return (<Text>{tarifa} UVT</Text>)
    default: break
  }
}

const formatDate = (date) => {
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
  return date.toLocaleDateString('en-GB', options);
}

const formatDateString = (dateString) => {
  const parts = dateString.split('-')
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

const getMonth = (date) => {
  let month = ''
  switch (date.slice(-2)) {
    case '01': month = "Enero"; break;
    case '02': month = "Febrero"; break;
    case '03': month = "Marzo"; break;
    case '04': month = "Abril"; break;
    case '05': month = "Mayo"; break;
    case '06': month = "Junio"; break;
    case '07': month = "Julio"; break;
    case '08': month = "Agosto"; break;
    case '09': month = "Septiembre"; break;
    case '10': month = "Octubre"; break;
    case '11': month = "Noviembre"; break;
    case '12': month = "Diciembre"; break;
    default: break;
  }
  return month;
}


const PDFFacturacionMunicipios = ({ data }) => {

  const setInfo = () => {
  }

  useEffect(() => {
    setInfo()
  })


  return (
    data[0] ?
      (
        <Document>
          <Page style={styles.body} size="A4">
            <View style={styles.view}>
              {/* FUNTION THAT RETURNS THE HEADER */}
              {headerPDF(data[0].MUNICIPIO, data[0])}

              <View style={[styles.row]}>
                {/* // FECHAS */}
                {fechasPDF(data[0].MUNICIPIO, data[0])}

                {/* MAIN TEXT */}
                {mainText(data[0].MUNICIPIO, data[0])}

                {/* PDF BODY */}
                {bodyPDF(data[0].MUNICIPIO, data[0])}

                {footerPDF(data[0].MUNICIPIO, data[0])}
              </View>
            </View>
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
          </Page>
        </Document>
      )
      :
      ""
  );
};

export default PDFFacturacionMunicipios;
